/**
 * Instagram API client - fetches posts via backend proxy
 */

import type { Result } from "@/types/layout";
import { getEnv } from "@/config/env";
import { getJson } from "@/api/http";

export interface InstagramPost {
  id: string;
  caption: string | null;
  mediaType: "IMAGE" | "VIDEO" | "CAROUSEL_ALBUM";
  mediaUrl: string;
  thumbnailUrl: string | null;
  permalink: string;
  timestamp: string;
}

/**
 * Fetches Instagram posts from the backend proxy endpoint
 */
export async function fetchInstagramPosts(
  accountId: string,
  count: number = 6,
  signal?: AbortSignal
): Promise<Result<InstagramPost[]>> {
  const env = getEnv();
  const url = `${env.apiBaseUrl}/instagram/${encodeURIComponent(accountId)}/posts?count=${count}`;
  return getJson<InstagramPost[]>(url, signal ? { signal } : undefined);
}
